import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta(): JSX.Element {
	const {
		data: { title, description, photo },
	} = usePageMeta();

	return (
		<>
			<Helmet>
				<title>{title}</title>
				<meta property="og:type" content="website" />
				<meta name="twitter:card" content="summary" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
			</Helmet>
			{photo && (
				<Helmet>
					<meta property="og:image" content={photo.url} />
					<meta property="og:image:secure_url" content={photo.url} />
					<meta property="og:image:width" content={`${photo.width}`} />
					<meta property="og:image:height" content={`${photo.height}`} />
					<meta property="twitter:image" content={photo.url} />
					<meta property="twitter:image:alt" content={title} />
				</Helmet>
			)}
		</>
	);
}
